// @flow

import { Lock, PenLine } from 'lucide-react';

import { Link } from 'react-router-dom';

import { useTranslator } from '@gandi/translate';

import { PillButton } from 'src/components/PillButton';
import { useFeatureFlags } from 'src/hooks/useFeatureFlag';

export function SetupPill({
  children,
  to,
  disabled = false,
}: {
  children: string | React.MixedElement,
  to?: string,
  disabled?: boolean,
}): React.MixedElement {
  const { __ } = useTranslator();
  const { FF_CART_OVERVIEW_NDS } = useFeatureFlags();

  const enabled = !disabled && !!to;

  if (FF_CART_OVERVIEW_NDS) {
    const icon = enabled ? <PenLine size={12} /> : <Lock size={12} />;

    return (
      <PillButton to={to} disabled={!enabled}>
        {children}
        {icon}
      </PillButton>
    );
  }

  // Legacy style
  return (
    <span>
      {children}
      {enabled && ' '}
      {enabled && to && <Link to={to}>{__('Change')}</Link>}
    </span>
  );
}
